import * as types from '../mutation-types'
import brandsRepository from '../../api/brandsRepository'

const state = {
  brandToCreate: {},
  brandToEdit: {},
  brands: [],
  brandsForCategory: [],
  isBrandCreated: false,
  isBrandDeleted: false,
  isBrandEdited: false
}

const getters = {
  brandToCreate: state => state.brandToCreate,
  brandToEdit: state => state.brandToEdit,
  brands: state => state.brands,
  brandsForCategory: state => state.brandsForCategory,
  isBrandCreated: state => state.isBrandCreated,
  isBrandDeleted: state => state.isBrandDeleted,
  isBrandEdited: state => state.isBrandEdited
}

const actions = {
  getBrands ({commit}) {
    return brandsRepository.getBrands().then((response) => {
      commit(types.SET_BRANDS, response.data)
    })
  },
  getBrandsForCategory ({commit}, categoryId) {
    return brandsRepository.getBrandsForCategory(categoryId).then((response) => {
      commit(types.SET_BRANDS_FOR_CATEGORY, response.data)
    })
  },
  createBrand ({commit}) {
    return brandsRepository.createBrand(state.brandToCreate).then((response) => {
      if (response.data.success) {
        commit(types.SET_BRAND_CREATED, true)
        commit(types.ADD_BRAND_TO_BRANDS, response.data)
      } else {
        commit(types.SET_BRAND_CREATED, false)
      }
    })
  },
  editBrand ({commit}) {
    return brandsRepository.editBrand(state.brandToEdit).then((response) => {
      if (response.data.success) {
        commit(types.EDIT_BRAND_IN_BRANDS, response.data.message)
        commit(types.SET_BRAND_EDITED, true)
      } else {
        commit(types.SET_BRAND_EDITED, false)
      }
    })
  },
  deleteBrand ({commit}, brandId) {
    return brandsRepository.deleteBrand(brandId).then((response) => {
      if (response.data.success) {
        commit(types.SET_BRAND_DELETED, true)
      } else {
        commit(types.SET_BRAND_DELETED, false)
      }
    })
  }
}

const mutations = {
  [types.SET_BRAND_TO_CREATE] (state, payload) {
    state.brandToCreate = payload
  },
  [types.SET_BRAND_TO_EDIT] (state, payload) {
    state.brandToEdit = payload
  },
  [types.SET_BRANDS] (state, payload) {
    state.brands = payload
  },
  [types.SET_BRANDS_FOR_CATEGORY] (state, payload) {
    state.brandsForCategory = payload
  },
  [types.SET_BRAND_CREATED] (state, payload) {
    state.isBrandCreated = payload
  },
  [types.SET_BRAND_DELETED] (state, payload) {
    state.isBrandDeleted = payload
  },
  [types.SET_BRAND_EDITED] (state, payload) {
    state.isBrandEdited = payload
  },
  [types.ADD_BRAND_TO_BRANDS] (state, payload) {
    state.brandsForCategory.push(payload.message)
  },
  [types.EDIT_BRAND_IN_BRANDS] (state, payload) {
    state.brandsForCategory.forEach((brand, index) => {
      if (brand.id === payload.id) {
        state.brandsForCategory.splice(index, 1)
        state.brandsForCategory.push(payload)
      }
    })
  },
  [types.REMOVE_BRAND_FROM_BRANDS] (state, payload) {
    state.brandsForCategory.forEach((brand, index) => {
      if (brand.id === payload) {
        state.brandsForCategory.splice(index, 1)
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
